import React from 'react';
import { Users, Rocket, Handshake } from 'lucide-react';

import './Leadership.css';
import { theme } from '../../theme/designSystem';

const pillars = [
    {
        icon: <Users size={22} color="#FFF" />,
        title: 'People & Technical Leadership',
        body: 'Mentor engineers, run system-design reviews, and set the coding and security standards the team builds against, growing technical leads who own their domains with autonomy.',
    },
    {
        icon: <Rocket size={22} color="#FFF" />,
        title: 'Execution & Reliability',
        body: 'Own the roadmap for federally-regulated platforms and ship them reliably with CI/CD, observability, and incident response that have kept compliance-critical systems running with zero regulatory lapses.',
    },
    {
        icon: <Handshake size={22} color="#FFF" />,
        title: 'Business & Stakeholder Impact',
        body: 'Translate compliance and platform strategy into commercial outcomes: directing a billing re-architecture that lifted revenue by about 10%, and partnering with resellers and executives to align technology investment with growth.',
    },
];

function Leadership() {
    return (
        <section className="leadership section-pad" id="leadership" style={{ backgroundColor: theme.tertiary }}>
            <div className="container">
                <div className="leadership--header">
                    <span className="eyebrow">Leadership &amp; Scope</span>
                    <h2 style={{ color: theme.primary }}>How I lead engineering</h2>
                    <p style={{ color: theme.textSecondary }}>
                        Turning technical vision into durable, compliant, revenue-driving systems.
                    </p>
                </div>

                <div className="leadership--grid">
                    {pillars.map((pillar, index) => (
                        <div
                            key={index}
                            className="leadership--card fade-in-up"
                            style={{ backgroundColor: theme.cardBg, borderColor: theme.border, animationDelay: `${index * 0.1}s` }}
                        >
                            <div className="leadership--icon-box" style={{ backgroundColor: theme.accent }}>
                                {pillar.icon}
                            </div>
                            <h3 style={{ color: theme.primary }}>{pillar.title}</h3>
                            <p style={{ color: theme.textSecondary }}>{pillar.body}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Leadership;
